// packages/api-client/src/services/commentsService.ts
import { getApiClient } from '../client';
import { handleApiError } from '../utils/handleApiError';
import type { ServiceResponse, UUID } from '@dopomogai/types';

export interface CommentItem {
  id: UUID;
  conversation_id: UUID;
  message_index: number;
  body: string;
  created_at: string;
  updated_at?: string | null;
  resolved_at?: string | null;
  author_name?: string | null;
}

export const commentsService = {
  addComment: (
    conversationId: UUID,
    messageIndex: number,
    payload: { body: string }
  ): ServiceResponse<CommentItem> => {
    return getApiClient()
      .post<CommentItem>(`/conversations/${conversationId}/messages/${messageIndex}/comments`, payload)
      .then((res) => res.data)
      .catch((err) => handleApiError(err, 'adding comment'));
  },

  listComments: (conversationId: UUID, messageIndex: number): ServiceResponse<CommentItem[]> => {
    return getApiClient()
      .get<CommentItem[]>(`/conversations/${conversationId}/messages/${messageIndex}/comments`)
      .then((res) => res.data)
      .catch((err) => handleApiError(err, 'listing comments'));
  },

  updateComment: (
    conversationId: UUID,
    commentId: UUID,
    payload: { body?: string; resolve?: boolean }
  ): ServiceResponse<CommentItem> => {
    return getApiClient()
      .patch<CommentItem>(`/conversations/${conversationId}/comments/${commentId}`, payload)
      .then((res) => res.data)
      .catch((err) => handleApiError(err, 'updating comment'));
  },
};